module.exports = __webpack_public_path__ + "img/ascend_gold2.b205e0af.png";